/**
 * Product operations available for signatories in the Person domain.
 * Shared between ContractType configuration and Person signatory modal.
 *
 * These represent Agrolend product lines (catálogo comercial).
 * Source of truth until a dynamic catalog table is created (see AF-2757 follow-up).
 */
export const PERSON_PRODUCTS = [
    'CORE',
    'KEEP',
    'CROSS',
    'PRIME',
    'FLOW',
    'SHIELD',
    'FORFAITING',
    'RISK_SHARING',
    'CLEAN',
    'CPR_F',
    'ORDER',
    'PACT',
    'CORE_PLUS',
    'CASHCOL',
] as const;

export type PersonProduct = typeof PERSON_PRODUCTS[number];

/** Human-readable labels for product codes (displayed in UI alongside the code). */
export const PERSON_PRODUCT_LABELS: Record<string, string> = {
    CORE: 'CORE (Cessão sem regresso)',
    KEEP: 'KEEP (Cessão com regresso)',
    CROSS: 'CROSS (Cessão sem regresso em US$)',
    PRIME: 'PRIME (Bônus de adimplência)',
    FLOW: 'FLOW (CDB Vinculado)',
    SHIELD: 'SHIELD (Aval da Indústria)',
    FORFAITING: 'FORFAITING (Desembolso da Indústria)',
    RISK_SHARING: 'Risk Sharing',
    CLEAN: 'CLEAN',
    CPR_F: 'CPR-F',
    ORDER: 'ORDER (Cessão de pedido)',
    PACT: 'PACT (CPR + Cessão Fiduciária)',
    CORE_PLUS: 'CORE+ (Cessão de recebíveis)',
    CASHCOL: 'CASHCOL (Cash Collateral)',
} satisfies Record<PersonProduct, string>;
